export function pageScrolled() {
  const className = 'page-scrolled';
  const scrollBreakPoint = 10;

  if (
    window.smoothScroll &&
    typeof window.smoothScroll.addListener === 'function'
  ) {
    window.smoothScroll.addListener(({ offset }) => {
      const scroll = offset.y;
      document.body.style.setProperty('--offsetY', scroll + 'px');

      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    });
  } else {
    const onScroll = () => {
      const scroll = window.scrollY || document.documentElement.scrollTop;
      document.body.style.setProperty('--offsetY', scroll + 'px');

      if (scroll >= scrollBreakPoint) {
        document.body.classList.add(className);
      } else {
        document.body.classList.remove(className);
      }
    };
  }
}
